export type SortDirection = 'ascending' | 'descending';

export interface TableSort {
  key: string;
  direction: SortDirection;
}

export interface TableSortOption {
  value: string;
  label: string;
  /** Shown while the option runs in its default direction. */
  description: string;
  /** Shown once the option has been reversed; states the opposite order in full. */
  reversedDescription: string;
  sorts: TableSort[];
}

/**
 * Flips the primary sort key only. Trailing keys stay as tie-breakers, so rows that tie
 * on the primary key keep the same predictable order in both directions — reversing the
 * tie-breaker too would shuffle equal rows for no reason the user can see.
 */
export function reverseSorts(sorts: TableSort[]): TableSort[] {
  return sorts.map((sort, index) => (index === 0 ? { ...sort, direction: sort.direction === 'ascending' ? 'descending' : 'ascending' } : sort));
}

/** Resolves the option plus its reversed flag into the sorts, description and arrow to render. */
export function resolveTableSort(option: TableSortOption, reversed: boolean): { sorts: TableSort[]; description: string; direction: SortDirection } {
  const sorts = reversed ? reverseSorts(option.sorts) : option.sorts;
  return {
    sorts,
    description: reversed ? option.reversedDescription : option.description,
    direction: sorts[0].direction,
  };
}
